import { Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { Typography, SizingMultiplier } from '@ocx/ui';
import { ModalPaper } from '@ocx-app/components/modals';

import { SelectPumpCarousel } from './select-pump-carousel.component';

type PumpSelectorProps = {
  pumps: string[];
  selectPump(pump: string): void;
};

export const PumpSelector = ({ pumps, selectPump }: PumpSelectorProps) => {
  return (
    <ModalPaper>
      <Stack py={5} spacing={SizingMultiplier.xl}>
        <Typography variant="h6" color="textSecondary" textAlign="center">
          <FormattedMessage
            id="selectPump:selectPumpCarouselTitle"
            defaultMessage="Select your pump"
            description="Select Pump: title for pump selector carousel"
          />
        </Typography>
        {pumps.length ? (
          <SelectPumpCarousel pumps={pumps} onPumpSelect={selectPump} />
        ) : (
          <Typography color="textSecondary" textAlign="center" mb={3}>
            <FormattedMessage
              id="selectPump:selectPumpCarouselPumpsUnavailable"
              defaultMessage="Pumps are not available"
              description="Select Pump: pumps are not available message"
            />
          </Typography>
        )}
      </Stack>
    </ModalPaper>
  );
};
